import { Show } from "shared/components";

export const FormatAddress = ({
  oneLineAddress
}: {
  oneLineAddress?: string;
}) => {
  if (!oneLineAddress) return null;

  const address = oneLineAddress.split(", ");
  const [street, city, state, zip, country] = address;

  // Handle US addresses
  if (country === "US" || country === "USA" || country === "United States")
    return (
      <address className="text-xxs text-content-1000 font-medium not-italic">
        {street}
        <br />
        {city}, {state} {zip}
        <br />
        United States
      </address>
    );

  // Handle all other addresses (international or non-standard format)
  return (
    <address className="text-xxs text-content-1000 font-medium not-italic">
      {address.map((line, index) => (
        <span key={index}>
          {line}
          <Show if={index < address.length - 1}>
            <br />
          </Show>
        </span>
      ))}
    </address>
  );
};
